import { useQuery } from '@tanstack/react-query';
import { fetchMyAttendances } from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

export interface MyAttendanceRange {
  startDate?: string;
  endDate?: string;
}

// X3 단계 1d (D6): PLAYER 본인 출퇴근 조회.
// query key namespacing: ['attendances','me', range] — 기간이 바뀌면 별도 캐시 엔트리.
export function useMyAttendances(range: MyAttendanceRange = {}, enabled = true) {
  return useQuery({
    queryKey: attendanceKeys.me(range.startDate ?? null, range.endDate ?? null),
    queryFn: () => fetchMyAttendances(range),
    enabled,
  });
}
